import React from 'react';

import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import { Heading } from '../../../homepage/Components/Heading/Heading';
import type { StepsBlock } from '../../@types/landingPages';
import { landingPageSectionLoadEvent, PAGE_SECTIONS } from '../../Pages/LandingPage.helpers';

import styles from './Steps.scss';

type StepsProps = Omit<StepsBlock, 'acf_fc_layout' | 'theme'> & {
  loading?: 'lazy' | 'eager';
};

export const Steps = ({ loading = 'lazy', steps = [], subtitle, title }: StepsProps) => {
  const { setRef } = usePageRefEvents({
    onRefTrigger: () => landingPageSectionLoadEvent(PAGE_SECTIONS.STEPS),
  });

  const validSteps = steps.filter((step) => step?.title && step?.image);

  if (!validSteps.length) {
    return null;
  }

  return (
    <div ref={(ref) => setRef(ref)} className={styles.wrapper}>
      {title ? <Heading
        center
        subtitle={subtitle}
        title={title}
      /> : null}
      <ol className={styles.steps}>
        {validSteps.map(({
          description, image, imageAvif, imageWebp, title: stepTitle,
        }, index) => (
          <li key={`${stepTitle}-${description}`} className={styles.step}>
            <picture>
              {imageAvif && <source srcSet={imageAvif} type="image/avif" />}
              {imageWebp && <source srcSet={imageWebp} type="image/webp" />}
              <img alt={stepTitle} height="440" loading={loading} src={image} width="440" />
            </picture>
            <span aria-hidden="true" className={styles.number}>{index + 1}</span>
            <h3>{stepTitle}</h3>
            {description && <p>{description}</p>}
          </li>
        ))}
      </ol>
    </div>
  );
};
